module.exports = __webpack_public_path__ + "media/images/iconPaginateFirst__inFrontOfAccent--dark-5d9477dc463ca5f68b04c5b9900ece78.png";